import * as angular from 'angular';
import StandardComponent from "components/standards/components/StandardComponent";
import SidebarPagesController from "components/sidebar-pages/controllers/sidebar-pages.controller";

"use strict";

class SidebarPages extends StandardComponent {

    // This will enable the debug mode of this class
    public debug = false;
    public moduleFolder = 'components/sidebar-pages';

    /**
     * PLease make sure that each function contain correct
     * documentation.
     */
    public bindings = {
    }

    // This will set what will be the controller of this component
    public controller : any = SidebarPagesController;

    // This will set an alias
    public controllerAs: string = 'sidebar';
}

angular.module('SidebarPagesModule').component('sidebarPages', <StandardComponent> new SidebarPages);
